<template>
	<FormKit
		v-if="formData"
		ref="formEl"
		v-model="formData[schemaRoot.name] as FormKitGroupValue"
		type="form"
		:form-class="'hdn-editor ' + $attrs.class"
		:name="schemaRoot.name"
		:plugins
		:actions="false"
	>
		<div class="loan-application-schemas">
			<FormKitSchema
				v-for="part in schemaParts"
				:key="(part.children as FormKitSchemaFormKit[])?.[0]?.name"
				:schema="part"
				:data="data"
				:library
			/>
		</div>
	</FormKit>
</template>

<script setup lang="ts">
import { useHdnForm } from "@/composables/useHdnForm";
import type { ValidationError } from "@/generatedApi";
import type {
	FormKitNode,
	FormKitGroupValue,
	FormKitSchemaNode,
	FormKitSchemaProps,
	FormKitSchemaFormKit,
} from "@formkit/core";
import { computed, ref } from "vue";

interface Props {
	schema: FormKitSchemaNode[] | null;
	validate: (formData: any) => Promise<ValidationError[]>;
}
const props = defineProps<Props>();

const schemaRoot = computed(() => props.schema?.[0] as FormKitSchemaFormKit);

// extract main children of formkit schema
const schemaParts = computed(
	() =>
		(
			(
				schemaRoot.value.children as FormKitSchemaNode[]
			)[0] as FormKitSchemaProps
		).children as FormKitSchemaFormKit[],
);
const formData = defineModel<FormKitGroupValue>();
const { data, plugins, library } = useHdnForm(props.validate);

// get the formkit node from the formkit element
const formEl = ref<{ node: FormKitNode } | null>(null);
const formKitNode = computed(() =>
	formEl.value?.node ? formEl.value.node : null,
);

// expose the formkit node so parent component can use it
defineExpose({
	formKitNode: formKitNode,
});
</script>
